export const video_pressets = {
  preview: {
    width: 854,
    height: 480,
  },
  start: {
    width: 854,
    height: 480,
  },
  hdv: {
    width: {
      max: 1280,
      ideal: 1280
    },
    height: {
      max: 720,
      ideal: 720
    }
  },
  high: {
    width: 854,
    height: 480,
  },
  medium: {
    width: 640,
    height: 360,
  },
  low: {
    width: 426,
    height: 240,
  },
} as const;
